// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-page {
  --privacy-ink: #263b32;
  --privacy-muted: #687970;
  --privacy-green: #117d66;
  min-height: 100vh;
  color: var(--privacy-ink);
  background:
    radial-gradient(ellipse at 50% 0, rgba(231, 242, 232, 0.75), transparent 42%),
    #f7faf7;
  font-family: "Karla", Arial, sans-serif;
}

.privacy-page *,
.privacy-page *::before,
.privacy-page *::after {
  box-sizing: border-box;
}

.privacy-header {
  display: flex;
  min-height: 76px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 0 max(24px, calc((100% - 1080px) / 2));
  border-bottom: 1px solid #dce6de;
  background: rgba(255, 255, 255, 0.82);
}

.privacy-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #183e33;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
}

.privacy-brand-mark {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border-radius: 10px;
  color: #fff;
  background: linear-gradient(145deg, #169579, #08725d);
  font-size: 18px;
}

.privacy-brand > span:last-child > span {
  color: #718278;
  font-weight: 400;
}

.privacy-header-link,
.privacy-footer a {
  color: var(--privacy-green);
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
}

.privacy-header-link:hover,
.privacy-footer a:hover,
.privacy-content a:hover {
  text-decoration: underline;
}

.privacy-content {
  width: min(calc(100% - 40px), 900px);
  margin: 42px auto 64px;
  padding: clamp(28px, 5vw, 60px);
  border: 1px solid #d1ded4;
  border-radius: 18px;
  background: linear-gradient(155deg, #fff 0%, #fbfdfb 38%, #f0f6ef 100%);
  box-shadow: 0 18px 50px rgba(43, 77, 55, 0.08);
}

.privacy-title-block {
  padding-bottom: 27px;
  border-bottom: 1px solid #dce7dd;
}

.privacy-eyebrow {
  margin: 0 0 12px;
  color: var(--privacy-green);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.4px;
}

.privacy-title-block h1 {
  margin: 0;
  color: #117d66;
  font-size: clamp(36px, 6vw, 48px);
  letter-spacing: -1.8px;
  line-height: 1.1;
}

.privacy-effective-date {
  margin: 14px 0 0;
  color: var(--privacy-muted);
  font-size: 14px;
}

.privacy-effective-date strong {
  color: #344b40;
}

.privacy-introduction {
  margin: 25px 0 0;
  padding: 21px 23px;
  border: 1px solid #d7e5d9;
  border-radius: 12px;
  background: rgba(231, 242, 232, 0.58);
}

.privacy-introduction p,
.privacy-section p {
  margin: 0 0 14px;
  color: #596c62;
  font-size: 15px;
  line-height: 1.75;
}

.privacy-introduction p:last-child,
.privacy-section p:last-child {
  margin-bottom: 0;
}

.privacy-introduction strong,
.privacy-section strong {
  color: #30483d;
}

.privacy-section {
  margin-top: 32px;
}

.privacy-section h2 {
  margin: 0 0 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e9e1;
  color: #167761;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.4px;
  text-align: left;
}

.privacy-section ul {
  display: grid;
  gap: 9px;
  margin: 12px 0 17px;
  padding-left: 23px;
  color: #596c62;
}

.privacy-section li {
  padding-left: 3px;
  font-size: 14px;
  line-height: 1.7;
}

.privacy-section li::marker {
  color: #269274;
}

.privacy-detail-list {
  gap: 12px !important;
}

.privacy-detail-list li strong {
  color: #30483d;
}

.privacy-table-wrap {
  overflow-x: auto;
  margin: 16px 0 12px;
  border: 1px solid #d8e3da;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.75);
}

.privacy-permissions-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.privacy-permissions-table th,
.privacy-permissions-table td {
  padding: 13px 15px;
  border-bottom: 1px solid #e4ece5;
  color: #596c62;
  font-size: 14px;
  line-height: 1.6;
  vertical-align: top;
}

.privacy-permissions-table thead th {
  color: #245443;
  background: #eaf3eb;
  font-weight: 700;
}

.privacy-permissions-table tbody th {
  min-width: 150px;
  color: #30483d;
  font-weight: 600;
}

.privacy-permissions-table tbody tr:last-child th,
.privacy-permissions-table tbody tr:last-child td {
  border-bottom: 0;
}

.privacy-note {
  padding: 13px 15px;
  border-left: 3px solid #55a88b;
  border-radius: 0 8px 8px 0;
  background: #edf5ee;
  font-size: 13px !important;
}

.privacy-section a {
  color: var(--privacy-green);
  font-weight: 600;
  overflow-wrap: anywhere;
  text-decoration: none;
}

.privacy-contact {
  padding: 22px;
  border: 1px solid #cbded0;
  border-radius: 12px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.8), #eaf3e9);
}

.privacy-contact h2 {
  border-bottom-color: #d5e3d6;
}

.privacy-footer {
  display: flex;
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px max(24px, calc((100% - 1080px) / 2));
  border-top: 1px solid #dce6de;
  color: #718078;
  background: rgba(255, 255, 255, 0.82);
  font-size: 12px;
}

.privacy-header-link:focus-visible,
.privacy-brand:focus-visible,
.privacy-footer a:focus-visible,
.privacy-content a:focus-visible {
  border-radius: 2px;
  outline: 3px solid rgba(17, 125, 102, 0.35);
  outline-offset: 3px;
}

@media (max-width: 600px) {
  .privacy-header {
    min-height: 68px;
    padding: 0 18px;
  }

  .privacy-brand {
    gap: 8px;
    font-size: 14px;
  }

  .privacy-brand-mark {
    width: 30px;
    height: 30px;
  }

  .privacy-header-link {
    font-size: 12px;
  }

  .privacy-content {
    width: calc(100% - 24px);
    margin: 20px auto 36px;
    padding: 25px 20px;
    border-radius: 14px;
  }

  .privacy-title-block {
    padding-bottom: 21px;
  }

  .privacy-title-block h1 {
    font-size: 36px;
  }

  .privacy-introduction {
    padding: 17px;
  }

  .privacy-section {
    margin-top: 27px;
  }

  .privacy-section h2 {
    font-size: 20px;
  }

  .privacy-introduction p,
  .privacy-section p {
    font-size: 14px;
  }

  .privacy-permissions-table th,
  .privacy-permissions-table td {
    padding: 11px;
    font-size: 13px;
  }

  .privacy-footer {
    padding: 14px 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/PrivacyPolicy/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB;;WAES;EACT,uCAAuC;AACzC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,+CAA+C;EAC/C,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,uEAAuE;EACvE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sEAAsE;AACxE;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kDAAkD;EAClD,6BAA6B;EAC7B,cAAc;EACd,qCAAqC;EACrC,eAAe;AACjB;;AAEA;;;;EAIE,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".privacy-page {\n  --privacy-ink: #263b32;\n  --privacy-muted: #687970;\n  --privacy-green: #117d66;\n  min-height: 100vh;\n  color: var(--privacy-ink);\n  background:\n    radial-gradient(ellipse at 50% 0, rgba(231, 242, 232, 0.75), transparent 42%),\n    #f7faf7;\n  font-family: \"Karla\", Arial, sans-serif;\n}\n\n.privacy-page *,\n.privacy-page *::before,\n.privacy-page *::after {\n  box-sizing: border-box;\n}\n\n.privacy-header {\n  display: flex;\n  min-height: 76px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 0 max(24px, calc((100% - 1080px) / 2));\n  border-bottom: 1px solid #dce6de;\n  background: rgba(255, 255, 255, 0.82);\n}\n\n.privacy-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #183e33;\n  font-size: 16px;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.privacy-brand-mark {\n  display: grid;\n  width: 34px;\n  height: 34px;\n  place-items: center;\n  border-radius: 10px;\n  color: #fff;\n  background: linear-gradient(145deg, #169579, #08725d);\n  font-size: 18px;\n}\n\n.privacy-brand > span:last-child > span {\n  color: #718278;\n  font-weight: 400;\n}\n\n.privacy-header-link,\n.privacy-footer a {\n  color: var(--privacy-green);\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.privacy-header-link:hover,\n.privacy-footer a:hover,\n.privacy-content a:hover {\n  text-decoration: underline;\n}\n\n.privacy-content {\n  width: min(calc(100% - 40px), 900px);\n  margin: 42px auto 64px;\n  padding: clamp(28px, 5vw, 60px);\n  border: 1px solid #d1ded4;\n  border-radius: 18px;\n  background: linear-gradient(155deg, #fff 0%, #fbfdfb 38%, #f0f6ef 100%);\n  box-shadow: 0 18px 50px rgba(43, 77, 55, 0.08);\n}\n\n.privacy-title-block {\n  padding-bottom: 27px;\n  border-bottom: 1px solid #dce7dd;\n}\n\n.privacy-eyebrow {\n  margin: 0 0 12px;\n  color: var(--privacy-green);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.4px;\n}\n\n.privacy-title-block h1 {\n  margin: 0;\n  color: #117d66;\n  font-size: clamp(36px, 6vw, 48px);\n  letter-spacing: -1.8px;\n  line-height: 1.1;\n}\n\n.privacy-effective-date {\n  margin: 14px 0 0;\n  color: var(--privacy-muted);\n  font-size: 14px;\n}\n\n.privacy-effective-date strong {\n  color: #344b40;\n}\n\n.privacy-introduction {\n  margin: 25px 0 0;\n  padding: 21px 23px;\n  border: 1px solid #d7e5d9;\n  border-radius: 12px;\n  background: rgba(231, 242, 232, 0.58);\n}\n\n.privacy-introduction p,\n.privacy-section p {\n  margin: 0 0 14px;\n  color: #596c62;\n  font-size: 15px;\n  line-height: 1.75;\n}\n\n.privacy-introduction p:last-child,\n.privacy-section p:last-child {\n  margin-bottom: 0;\n}\n\n.privacy-introduction strong,\n.privacy-section strong {\n  color: #30483d;\n}\n\n.privacy-section {\n  margin-top: 32px;\n}\n\n.privacy-section h2 {\n  margin: 0 0 12px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e0e9e1;\n  color: #167761;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.4px;\n  text-align: left;\n}\n\n.privacy-section ul {\n  display: grid;\n  gap: 9px;\n  margin: 12px 0 17px;\n  padding-left: 23px;\n  color: #596c62;\n}\n\n.privacy-section li {\n  padding-left: 3px;\n  font-size: 14px;\n  line-height: 1.7;\n}\n\n.privacy-section li::marker {\n  color: #269274;\n}\n\n.privacy-detail-list {\n  gap: 12px !important;\n}\n\n.privacy-detail-list li strong {\n  color: #30483d;\n}\n\n.privacy-table-wrap {\n  overflow-x: auto;\n  margin: 16px 0 12px;\n  border: 1px solid #d8e3da;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.75);\n}\n\n.privacy-permissions-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n}\n\n.privacy-permissions-table th,\n.privacy-permissions-table td {\n  padding: 13px 15px;\n  border-bottom: 1px solid #e4ece5;\n  color: #596c62;\n  font-size: 14px;\n  line-height: 1.6;\n  vertical-align: top;\n}\n\n.privacy-permissions-table thead th {\n  color: #245443;\n  background: #eaf3eb;\n  font-weight: 700;\n}\n\n.privacy-permissions-table tbody th {\n  min-width: 150px;\n  color: #30483d;\n  font-weight: 600;\n}\n\n.privacy-permissions-table tbody tr:last-child th,\n.privacy-permissions-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.privacy-note {\n  padding: 13px 15px;\n  border-left: 3px solid #55a88b;\n  border-radius: 0 8px 8px 0;\n  background: #edf5ee;\n  font-size: 13px !important;\n}\n\n.privacy-section a {\n  color: var(--privacy-green);\n  font-weight: 600;\n  overflow-wrap: anywhere;\n  text-decoration: none;\n}\n\n.privacy-contact {\n  padding: 22px;\n  border: 1px solid #cbded0;\n  border-radius: 12px;\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.8), #eaf3e9);\n}\n\n.privacy-contact h2 {\n  border-bottom-color: #d5e3d6;\n}\n\n.privacy-footer {\n  display: flex;\n  min-height: 70px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px max(24px, calc((100% - 1080px) / 2));\n  border-top: 1px solid #dce6de;\n  color: #718078;\n  background: rgba(255, 255, 255, 0.82);\n  font-size: 12px;\n}\n\n.privacy-header-link:focus-visible,\n.privacy-brand:focus-visible,\n.privacy-footer a:focus-visible,\n.privacy-content a:focus-visible {\n  border-radius: 2px;\n  outline: 3px solid rgba(17, 125, 102, 0.35);\n  outline-offset: 3px;\n}\n\n@media (max-width: 600px) {\n  .privacy-header {\n    min-height: 68px;\n    padding: 0 18px;\n  }\n\n  .privacy-brand {\n    gap: 8px;\n    font-size: 14px;\n  }\n\n  .privacy-brand-mark {\n    width: 30px;\n    height: 30px;\n  }\n\n  .privacy-header-link {\n    font-size: 12px;\n  }\n\n  .privacy-content {\n    width: calc(100% - 24px);\n    margin: 20px auto 36px;\n    padding: 25px 20px;\n    border-radius: 14px;\n  }\n\n  .privacy-title-block {\n    padding-bottom: 21px;\n  }\n\n  .privacy-title-block h1 {\n    font-size: 36px;\n  }\n\n  .privacy-introduction {\n    padding: 17px;\n  }\n\n  .privacy-section {\n    margin-top: 27px;\n  }\n\n  .privacy-section h2 {\n    font-size: 20px;\n  }\n\n  .privacy-introduction p,\n  .privacy-section p {\n    font-size: 14px;\n  }\n\n  .privacy-permissions-table th,\n  .privacy-permissions-table td {\n    padding: 11px;\n    font-size: 13px;\n  }\n\n  .privacy-footer {\n    padding: 14px 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
